<template>
  <div
    class="garage-opinion"
  >
    <div class="garage-opinion__header">
      <div class="garage-opinion__header-wrapper">
        <div class="garage-opinion__header-logo">{{ garageOpinion.author?.substring(0, 1).toLocaleUpperCase() }}</div>
        <div>
          <div
            class="garage-opinion__author"
          >{{ author }}</div>
          <div
            class="garage-opinion__created-at"
          >{{ dateFormat(garageOpinion?.createdAt) }}</div>
        </div>
      </div>

      <div
        class="garage-opinion__header-rating"
      >
        <div class="garage-opinion__rating-stars">
          <NuxtImg
            v-for="(item, index) in 6"
            alt="Ocena DobryMechanik.pl"
            width="18px"
            height="18px"
            class="garage-opinion__rating-star"
            :src="getStar(garageOpinion.rating || 0, index).toString()"
          />
        </div>
      </div>
    </div>

    <div class="garage-opinion__arranged-by-google">
      <NuxtImg
        src="/_nuxt/poweredByGoogle.png"
        alt="Ocena z Google"
        width="106px"
        height="auto"
        class="mb-1"
      />
    </div>

    <div
      class="garage-opinion__description"
    >
      <p>
        {{ opinionDescription }}
        <span
          @click="expandableContent.description = !expandableContent.description"
          class="garage-opinion__description-show-more"
          v-if="(garageOpinion.description?.length || 0) > shortDescriptionLength"
        >{{ expandableContent.description ? 'Zwiń' : 'Rozwiń' }}
        </span>
      </p>
    </div>

  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { getStar } from '@/helpers/get-star';
import { dateFormat } from '~/helpers/dayjs';
import type { GarageGooglePlaceReview } from '~/api/docs/app';

interface IProps {
  garageOpinion: GarageGooglePlaceReview;
}

// data
const expandableContent: Ref<any> = ref({
  rating: false,
  description: false,
  answer: false
});
const shortDescriptionLength: number = 140;

// props
const props = defineProps<IProps>();

// computed
const opinionDescription = computed(() => {
  return props.garageOpinion.description
    ? !expandableContent.value.description && props.garageOpinion.description.length > shortDescriptionLength
      ? props.garageOpinion.description.substring(0, shortDescriptionLength) + '...'
      : props.garageOpinion.description
    : null;
});

const author = computed(() => {
  return props.garageOpinion.author?.split(" ")[0];
});
</script>

<style lang="scss">
@import url('assets/styles/components/garage-opinion-element.scss');
</style>
